import { c as _c } from "react/compiler-runtime";
import { Typography, Stack } from '@mui/material';
import type { BackupPolicyType, ResourceType } from '@repo/api-gw-sdk';
import Image, { type StaticImageData } from 'next/image';
import type { ReactNode } from 'react';
import { ResourceTypes } from '@/data/inventory/resourceTypes';
import AllExcluded from '../../../../../../../public/statics/images/illustrations/resource-selection/all_excluded.png';
import AllIncluded from '../../../../../../../public/statics/images/illustrations/resource-selection/all_included.png';
import { isPitrPolicyType } from '../../backupPoliciesTypes';
const DynamicResourcesEmptyState = t0 => {
  const $ = _c(22);
  const {
    title,
    description,
    illustration,
    alt,
    size
  } = t0;
  const t1 = size === "small" ? "24px" : "40px";
  const t2 = size === "small" ? "320px" : "480px";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      gap: t1,
      marginX: "40px",
      alignItems: "center",
      width: t2,
      alignSelf: "center",
      justifySelf: "center"
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = size === "small" ? 60 : 240;
  let t5;
  if ($[3] !== alt || $[4] !== illustration || $[5] !== t4) {
    t5 = <Image alt={alt} width={t4} src={illustration} className="h-auto" />;
    $[3] = alt;
    $[4] = illustration;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = size === "small" ? "8px" : "12px";
  let t7;
  if ($[7] !== t6) {
    t7 = {
      gap: t6,
      alignItems: "center"
    };
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== size || $[10] !== title) {
    t8 = typeof title === "string" ? <Typography variant={size === "small" ? "subtitle1" : "h3"}>{title}</Typography> : title;
    $[9] = size;
    $[10] = title;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== description) {
    t9 = description && <Typography variant="body1" sx={{
      textAlign: "center",
      width: "320px"
    }}>{description}</Typography>;
    $[12] = description;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t7 || $[15] !== t8 || $[16] !== t9) {
    t10 = <Stack sx={t7}>{t8}{t9}</Stack>;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t3 || $[20] !== t5) {
    t11 = <Stack sx={t3}>{t5}{t10}</Stack>;
    $[18] = t10;
    $[19] = t3;
    $[20] = t5;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
export const DynamicResourcesAllIncluded = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    description,
    selectedResourceTypes,
    policyType
  } = t0;
  const size = t1 === undefined ? "large" : t1;
  let t2;
  if ($[0] !== policyType || $[1] !== selectedResourceTypes) {
    t2 = selectedResourceTypes && isPitrPolicyType(policyType) ? selectedResourceTypes?.map(_temp).join(", ") : "";
    $[0] = policyType;
    $[1] = selectedResourceTypes;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `All ${t2} resources are included`;
  let t4;
  if ($[3] !== description || $[4] !== size || $[5] !== t3) {
    t4 = <DynamicResourcesEmptyState title={t3} alt="All resources are included" description={description} illustration={AllIncluded} size={size} />;
    $[3] = description;
    $[4] = size;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export const DynamicResourcesAllExcluded = t0 => {
  const $ = _c(3);
  const {
    size: t1,
    description
  } = t0;
  const size = t1 === undefined ? "large" : t1;
  let t2;
  if ($[0] !== description || $[1] !== size) {
    t2 = <DynamicResourcesEmptyState title="All resources are excluded" alt="All resources are excluded" description={description} illustration={AllExcluded} size={size} />;
    $[0] = description;
    $[1] = size;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(type) {
  return ResourceTypes[type].displayName;
}